import { IManual } from 'interfaces/manual';
import { IPaginationParams, IPaginationResponse } from 'interfaces/pagination';
import * as rxjs from 'rxjs';

import apiService, { ApiService } from './api';

export class ManualService {
  constructor(private apiService: ApiService) { }

  public list(params: IPaginationParams): rxjs.Observable<IPaginationResponse<IManual>> {
    return this.apiService.get('/manual', params);
  }

  public save(manual: FormData): rxjs.Observable<any> {
    return this.apiService.upload('/manual', manual);
  }

  public delete(id: number): rxjs.Observable<void> {
    return this.apiService.delete(`/manual/${id}`);
  }
}

const manualService = new ManualService(apiService);
export default manualService;